import { render, staticRenderFns } from "./SimpleFormCard.vue?vue&type=template&id=724ee820"
import script from "./SimpleFormCard.vue?vue&type=script&lang=js"
export * from "./SimpleFormCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports